import {ErrorMsg} from 'components/ErrorReporter';
import get from 'lodash/get';
import React, {FC, ReactElement} from 'react';
import 'url-polyfill';
import {isProdBuild} from 'utils/env';
import {getPageSearchParam} from 'utils/urls';

export type FrameSelectorPage =
  | (() => ReactElement)
  | {
      [partId: string]: FrameSelectorPage;
    };

export type Props = {
  frameId?: string;
  defaultFrame?: string;
  config: FrameSelectorPage;
};

export const getFrameIdGHref = (parts: string[]) => {
  const path = parts.join('/');
  const hostBase = document.location.href.split('?')[0];
  return `${hostBase}?frame=${path}`;
};

export const FrameIdLink = ({parts, text}: {parts: string[]; text?: string}) => {
  return <a href={getFrameIdGHref(parts)}>{text ?? parts.join('/')}</a>;
};

const listsEnabled = !isProdBuild;

const FrameSelector: FC<Props> = ({frameId: frameIdProp, defaultFrame, config}) => {
  const path: string[] = (frameIdProp ?? getPageSearchParam('frame') ?? defaultFrame ?? '')
    .split('/')
    .filter(v => v !== '');
  const pathStr = path.join('/');

  const parentPath = path.slice(0, -1);
  if (listsEnabled) {
    window.addEventListener('keydown', e => {
      if (e.key === 'Enter' && e.ctrlKey) {
        window.location.href = getFrameIdGHref(parentPath);
      }
    });
  }

  if (!listsEnabled && path.length === 0) {
    throw new ErrorMsg(`Пустой параметр "frame"`);
  }
  const dir: FrameSelectorPage = path.length === 0 ? config : get(config, path);
  if (typeof dir === 'undefined') {
    throw new ErrorMsg(`Фрейм "${pathStr}" не найден`);
  } else if (typeof dir === 'function') {
    return dir();
  } else if (!listsEnabled) {
    throw new ErrorMsg(`Неполное значение параметра "frame": "${pathStr}"`);
  }

  return (
    <div style={{margin: 10}}>
      {path.length > 0 ? <FrameIdLink parts={parentPath} text="↑" /> : null}
      {Object.entries(dir).map(([curPart, curPartPage]: [string, FrameSelectorPage]) => (
        <div key={curPart}>
          <FrameIdLink
            parts={[...path, curPart]}
            text={curPart + (typeof curPartPage === 'function' ? '' : '/')}
          />
        </div>
      ))}
    </div>
  );
};

export default FrameSelector;
